export class ICredentials {
    id;
    name;
    type;
    data;
    constructor(nodeCredentials, type, data) {
        this.id = nodeCredentials.id ?? undefined;
        this.name = nodeCredentials.name;
        this.type = type;
        this.data = data;
    }
}
export class ICredentialsHelper {
}
const __brand = Symbol('resolvedFilePath');
export const ChatNodeMessageType = {
    WITH_BUTTONS: 'with-buttons',
};
/**
 * This class serves as the base for all nodes using the new context API
 * having this as a class enables us to identify these instances at runtime
 */
export class Node {
}
export const NodeConnectionTypes = {
    AiAgent: 'ai_agent',
    AiChain: 'ai_chain',
    AiDocument: 'ai_document',
    AiEmbedding: 'ai_embedding',
    AiLanguageModel: 'ai_languageModel',
    AiMemory: 'ai_memory',
    AiOutputParser: 'ai_outputParser',
    AiRetriever: 'ai_retriever',
    AiReranker: 'ai_reranker',
    AiTextSplitter: 'ai_textSplitter',
    AiTool: 'ai_tool',
    AiVectorStore: 'ai_vectorStore',
    Main: 'main',
};
export const nodeConnectionTypes = Object.values(NodeConnectionTypes);
//# sourceMappingURL=interfaces.js.map